













import Vue from 'vue';
import isGranted from '@/auth/isGranted';
import { openModal } from 'mycorems-app-shared';
import AddClientsModal from './AddClientsModal.vue';

export default Vue.extend({
  props: {
    agencyId: {
      type: String,
      required: true,
    },
  },
  methods: {
    openModal(): void {
      openModal(AddClientsModal, {
        agencyId: this.agencyId,
      }).onOk(() => {
        this.$emit('imported');
      });
    },
    isGranted,
  },
});
